import { ILesson } from '@/@types'
import { create } from 'zustand'

interface LessonsState {
  selectedItem: ILesson | null
  setSelectedItem: (value: ILesson | null) => void
  clearSelectedItem: () => void
}

export const useLessonsStore = create<LessonsState>((set) => ({
  selectedItem: null,
  setSelectedItem: (value: ILesson | null) => set({ selectedItem: value }),
  clearSelectedItem: () => set({ selectedItem: null }),
}))
